import React, {useEffect, useState} from 'react';
import {Hub} from "@aws-amplify/core";
import {DataStore} from "@aws-amplify/datastore";
import {Navigate} from "react-router-dom";
import {UserApplicant, UserMortgage} from "../../../models";
import {useAuthenticator} from "@aws-amplify/ui-react";
import {modelClasses} from "../../../common";
import SettingThingsUp from "../../ui/SettingThingsUp";
import {Auth} from "aws-amplify";

function DatastoreInit(props) {
    const [redirect, setRedirect] = useState(false)
    const {user, signOut} = useAuthenticator((context) => [context.user]);
    useEffect(()=>{
        const start = async ()=>{
            await DataStore.clear()
            await DataStore.start()
        }
        start()
    },[])
    //redirect if a supporter or admin
    if (!user) {
        signOut()
        return <Navigate to={'/login'}/>
    }
    if (user.signInUserSession.accessToken.payload.hasOwnProperty("cognito:groups") && user.signInUserSession.accessToken.payload["cognito:groups"].includes("admins")) {
        return <Navigate to={'/admin'}/>
    }

    const listener = Hub.listen("datastore", async hubData => {
        const {event, data} = hubData.payload;
        if (event === "ready") {
            listener()
            init()
        }
    })
    const init = async () => {
        let m = (await DataStore.query(UserMortgage)).filter(item => item.username === user.attributes.sub);
        if (!m.length) {
            // console.log('no tables')
            const m = await createMortgage()
            setRedirect(true)
        } else {
            setRedirect(true)
        }
    }

    const createApplicant = async (isApplicantOne) => {
        //console.log('createApplicant')
        try {
            let attributes = {}
            attributes.properties = []
            attributes.assets = []
            attributes.debts = []
            if (isApplicantOne) {
                attributes.email = user.attributes.email
                attributes.firstName = user.attributes.given_name
                attributes.mobile = user.attributes.phone_number
            }
            const app = await DataStore.save(new UserApplicant(attributes))
            const myModels = await Promise.all(
                ["personal", "employment", "income", "financial", "tax"].map(item => {
                    let attr = {applicant: app}
                    if (item === 'personal') {
                        attr.dateOfBirth = isApplicantOne ? props.values.app1DateOfBirth : props.values.app2DateOfBirth
                    }
                    //console.log(attr)
                    return DataStore.save(new modelClasses[item](attr))
                })
            )
            //console.log(myModels)
            const applicant =  await DataStore.save(UserApplicant.copyOf(app, item => {
                for (const {k, v} in attributes) {
                    if (k) item[k] = v
                }
                item.personal = myModels[0]
                item.userApplicantPersonalId = myModels[0].id
                item.employment = myModels[1]
                item.userApplicantEmploymentId = myModels[1].id
                item.income = myModels[2]
                item.userApplicantIncomeId = myModels[2].id
                item.financial = myModels[3]
                item.userApplicantFinancialId = myModels[3].id
                item.tax = myModels[4]
                item.userApplicantTaxId = myModels[4].id
            }))
            //console.log(applicant)
            return applicant
        } catch (error) {
            console.log("Error saving applicant", error);
        }
    }
    const createMortgage = async () => {
        try {
            const credentials = await Auth.currentUserCredentials();

            //create Applicants
            const app1 = await createApplicant(true)
            const app2 = await createApplicant()

            //create Mortgage
            const mAttributes = {}
            mAttributes.username = user.attributes.sub
            mAttributes.uploads = []
            mAttributes.progress = []
            mAttributes.applicationStage = 'CALCULATE'
            mAttributes.twoApplicants = !props.values.goingAlone
            mAttributes.mortgageType = props.values.mortgagePurpose === 'REFINANCE' ? 'REFINANCE' : 'PURCHASE'
            mAttributes.applicant1 = app1
            mAttributes.applicant1ID = app1.id
            mAttributes.applicant2 = app2
            mAttributes.applicant2ID = app2.id
            mAttributes.identityId = credentials.identityId
            let mort = await DataStore.save(new UserMortgage(mAttributes))
            // create mortgage hasOne items
            const mortgageModels = await Promise.all(
                ["needs", "existing", "property", "requirement"].map(item => {
                    let attr = {mortgage: mort}
                    switch (item) {
                        case "property":
                            if (props.values.mortgagePurpose === 'REFINANCE') {
                                attr.propertyValue = props.values.estimatedValue
                                attr.berScore = props.values.berScore
                            } else {
                                attr.purchaseStage = props.values.purchaseStage
                                attr.intendedUse = props.values.mortgagePurpose
                                if (['RESEARCHING', 'VIEWING'].includes(props.values.purchaseStage)) {
                                    attr.addressKnown = false
                                    attr.spendAmount = props.values.estimatedValue
                                } else {
                                    attr.addressKnown = true
                                    attr.purchasePrice = props.values.estimatedValue
                                }
                            }
                            break
                        case "requirement":
                            attr.loanRequired = props.values.borrowAmount
                            attr.loanTerm = props.values.borrowTerm
                            attr.combinedGrossEarnings = props.values.grossEarnings
                            attr.combinedDependants = props.values.totalDependants
                           // attr.combinedLoanRepayments = props.values.monthlyLoanRepayments
                            if (props.values.mortgagePurpose === 'REFINANCE') {

                            }
                            break
                        case "existing":
                            if (props.values.mortgagePurpose === 'REFINANCE') {
                               // attr.currentRate = props.values.existingRate
                                attr.monthlyPayment = props.values.existingPayment
                            }
                            break
                        default:
                    }
                    return DataStore.save(new modelClasses[item](attr))
                })
            )
            return await DataStore.save(UserMortgage.copyOf(mort, item => {
                // Update the values on {item} variable to update DataStore entry
                item.needs = mortgageModels[0]
                item.existing = mortgageModels[1]
                item.property = mortgageModels[2]
                item.requirement = mortgageModels[3]
            }));
        } catch (error) {
            console.log("Error creating mortgage", error);
        }
    }

    if (redirect) {
        return <Navigate to='/'/>
    }
    return <SettingThingsUp/>
}

export default DatastoreInit;